<template>
  <div class="vue-component-holder">
    <my-header></my-header>
    <left-menu></left-menu>

    <!-- Page -->
    <div class="page">
      <div class="page-header">
        <h1 class="page-title">{{ t('menUsers') }}</h1>
        <!--<ol class="breadcrumb">-->
        <!--<li class="breadcrumb-item"><a href="../index.html">Home</a></li>-->
        <!--<li class="breadcrumb-item"><a href="javascript:void(0)">Tables</a></li>-->
        <!--<li class="breadcrumb-item active">Bootstrap</li>-->
        <!--</ol>-->
      </div>

      <div class="page-content container-fluid bottom-padding-zero">
        <div class="panel margin-bottom-zero">
          <div class="panel-body">

            <div v-if="languagesLoaded && dataLoaded">
              <div class="btn-group toolbar" role="group">
                <button type="button" class="btn btn-success" @click="newUserModalOpen">
                  <i class="icon wb-plus" aria-hidden="true"></i>
                </button>
              </div>

              <table
                data-unique-id="id"
                class="tableToolbar"
                data-mobile-responsive="true"
                data-row-style="rowStyle">
                <thead>
                <tr>
                  <th data-field="FirstName">{{ t('lblFirstName') }}</th>
                  <th data-field="LastName">{{ t('lblLastName') }}</th>
                  <th data-field="Email">{{ t('lblEmail') }}</th>
                  <th data-field="MobilePhone">{{ t('lblMobilePhone') }}</th>
                  <th data-field="Actions" data-halign="center" data-align="center">Actions</th>
                </tr>
                </thead>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- End Page -->

    <my-footer/>

    <edit-modal
      @updateRow="updateRow"
      v-if="languagesLoaded"
      ref="editModal"
    />
    <add-modal
      @refresh="gridLoadData"
      v-if="languagesLoaded"
    />

  </div>

</template>

<script>
import MyHeader         from '../layout-header'
import LeftMenu         from '../layout-left-menu'
import MyFooter         from '../layout-footer'
import EditModal        from './EditModal'
import AddModal         from './AddModal'
import UserResource     from './../../../model/resource/User'
import LanguageResource from '@/model/resource/Language'

export default {
  components: {
    LeftMenu,
    MyHeader,
    MyFooter,
    EditModal,
    AddModal
  },
  data () {
    return {
      grid:            null,
      data:            {},
      tableGrid:       {},
      languagesLoaded: false,
      dataLoaded:      false,
      scrollFired:     false,
      limit:           UserResource.defaults().limit,
      offset:          UserResource.defaults().offset,
      refreshCalled:   false,
      searchedText:    '',
      modal:           undefined
    }
  },
  created:    function () {
    let module = this

    this.initData(null, { limit: this.limit, offset: this.offset })
    this.initLanguages()

    // fix modal close -> rool to row
    var savedScrollPosition
    $(document).on('show.bs.modal', '.modal', function () {
      savedScrollPosition = $(window).scrollTop()
    })

    $(document).on('hidden.bs.modal', '.modal', function () {
      window.scrollTo(0, savedScrollPosition)
    })

    $(document).on('click', '.js-grid-remove-modal', function () {
      let itemId = $(this).data('item-id')

      module.removeItem(itemId)
    })

    window.addEventListener('scroll', this.handleScroll)
  },

  updated () {
    this.initGrid()

    let module = this

    $(document).on('click', '#users.js-grid-edit-modal', function () {
      // @TODO: hack jquery
      if (!module.modal) {
        module.modal = module.$refs.editModal
      }

      let itemId = $(this).data('item-id')

      let userData = module.selectUser(itemId)
      module.modal.setDefaults(userData.data)

      $('#userEditModal').modal('show')
      $('#userEditModal').on('shown.bs.modal', function () {
        $(this).find('input').first().focus()
      })
    })
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    initData (callback, args) {
      UserResource.find(args)
                  .then(response => {
                    this.data = response.data
                    this.preprocessData()

                    if (callback) {
                      callback()
                    }

                    this.dataLoaded = true
                  })
                  .catch(e => {
                    console.error(e)
                  })
    },
    initGrid () {
      this.grid = $('.tableToolbar').bootstrapTable({
        data:         this.data,
        search:       true,
        showRefresh:  true,
        showToggle:   true,
        showColumns:  true,
        toolbar:      '.toolbar',
        iconSize:     'outline',
        icons:        {
          refresh: 'wb-refresh',
          toggle:  'wb-order',
          columns: 'wb-list-bulleted'
        },
        onRefresh:    () => {
          this.limit  = 20
          this.offset = 1
          this.grid.bootstrapTable('resetSearch')
          this.searchedText = ''
          this.gridLoadData()
        },
        customSearch: (text) => {
          if (text === undefined || text === this.searchedText) {
            return
          }

          this.limit  = UserResource.defaults().limit
          this.offset = UserResource.defaults().offset

          this.searchedText = text

          this.gridLoadData()
        }
      })
    },
    preprocessData () {
      for (let i = 0; i < this.data.length; i++) {
        this.data[i].Actions = '' +
          '<div class=\'btn-group\'>' +
          '<a href=\'#\' id=\'users\' class=\'btn btn-sm btn-icon btn-default btn-outline on-default edit-row js-grid-edit-modal\' data-item-id=\'' +
          this.data[i].id + '\' data-toggle=\'tooltip\' data-original-title=\'Edit\'>' +
          '<i class=\'icon wb-edit\' aria-hidden=\'true\'></i>' +
          '</a>' +
          '<a href=\'#\' class=\'btn btn-sm btn-icon btn-default btn-outline on-default remove-row js-grid-remove-modal\' data-item-id=\'' +
          this.data[i].id +
          '\' data-toggle=\'tooltip\' data-original-title=\'Remove\'><i class=\'icon wb-trash\' aria-hidden=\'true\'></i>' +
          '</a>' +
          '</div>'
      }
    },
    newUserModalOpen () {
      $('#addUserModal').modal('show')
      $('#addUserModal').on('shown.bs.modal', function () {
        $(this).find('input').first().focus()
      })
    },
    removeItem (itemId) {
      let remove = (id) => {
        UserResource.delete(id)
                    .then(response => {
                      this.grid.bootstrapTable('removeByUniqueId', id)
                    })
                    .catch
                    (e => {
                      console.error(e)
                    })
      }

      bootbox.confirm({
        size:      'small',
        title:     'Smazat uživatele',
        message:   'Opravdu chcete smazat uživatele?',
        className: 'bootbox modal fade modal-fade-in-scale-up modal-simple',
        buttons:   {
          confirm: {
            className: 'btn btn-success'
          }
        },
        callback (result) {
          if (result) {
            remove(itemId)
          }
        }
      })
    },
    selectUser (userId) {
      userId = parseInt(userId)

      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id === userId) {
          return { index: i, data: this.data[i] }
        }
      }
    },
    updateRow (args) {
      let userData = this.selectUser(args.id)

      Object
        .keys(args.row)
        .map(key => this.data[userData.index][key] = args.row[key])

      this.grid.bootstrapTable('updateByUniqueId', args)
    },
    gridLoadData (method = 'load') {
      let originalData = this.data
      this.initData(() => {
        this.grid.bootstrapTable(method, this.data)
        for (let i = 0; i < this.data.length; i++) {
          originalData.push(this.data[i])
        }
        this.data = originalData
      }, {
        query:  this.searchedText,
        limit:  this.limit,
        offset: this.offset
      })
    },
    initLanguages () {
      LanguageResource.get()
                      .then(response => {
                        this.$store.commit('setLanguages', response.data)
                        this.languagesLoaded = true
                      })
                      .catch(error => {
                      })
    },
    handleScroll () {
      let y      = window.pageYOffset
      let result = $(document).height() - $(window).height()

      if (result >= y + 80 && this.scrollFired) {
        this.scrollFired = false

        return
      }

      if (result <= y + 80 && !this.scrollFired) {
        this.scrollFired = true
        this.offset++

        this.gridLoadData('append')
      }
    }
  }
}
</script>
